import Box from "@mui/material/Box";
import useRequestedDocumentRepository from "../../../../../../repository/emergency/useRequestedDocumentRepository";
import {useEffect, useState} from "react";
import isNull from "../../../../../../mixin/isNull";
import Detail from "./Detail";

export default function ({interventionId}) {
    const requestedDocumentRepository = useRequestedDocumentRepository();
    /** @type RequestedDocument[] */
    const requestedDocuments = requestedDocumentRepository.findAllByInterventionId(interventionId).select();
    const [clientPriceCertificate, setClientPriceCertificate] = useState(null);

    useEffect(() => {
        requestedDocumentRepository.findAllByInterventionId(interventionId).exec();
    }, []);

    useEffect(() => {
        if (isNull(requestedDocuments) || requestedDocuments.length === 0) return;

        const clientPriceCertificates = requestedDocuments.filter(requestedDocument => requestedDocument.getName().startsWith("Attestation de RAC"));

        setClientPriceCertificate(clientPriceCertificates[clientPriceCertificates.length - 1]);
    }, [JSON.stringify(requestedDocuments)]);

    if (isNull(requestedDocuments) || requestedDocuments.length === 0 || isNull(clientPriceCertificate)) return null;

    return (
        <Box>
            <Detail requestedDocumentId={clientPriceCertificate.getId()}/>
        </Box>
    )
}